var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlbums(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51313 5.768L5.00113 5L4.00113 6.5H8.50113L6.75113 4L5.51313 5.768Z",
    fill: "#DA673F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75263 4.49519C5.16767 4.49519 5.50413 4.15873 5.50413 3.74369C5.50413 3.32865 5.16767 2.99219 4.75263 2.99219C4.33759 2.99219 4.00113 3.32865 4.00113 3.74369C4.00113 4.15873 4.33759 4.49519 4.75263 4.49519Z",
    fill: "#DA673F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1H3C2.397 1 1.5 1.3995 1.5 2.5V9.5C1.5 10.6005 2.397 11 3 11H10.5V10H3.006C2.775 9.994 2.5 9.903 2.5 9.5C2.5 9.097 2.775 9.006 3.006 9H10.5V2C10.5 1.4485 10.0515 1 9.5 1ZM9.5 8H2.5V2.5C2.5 2.097 2.775 2.006 3 2H9.5V8Z",
    fill: "#DA673F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbums);
export default __webpack_public_path__ + "static/media/albums.f1c14be2b85b938095798e3d4bec4297.svg";
export { ForwardRef as ReactComponent };